// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { styled } from "@mui/material/styles";
// import TableRow from "@mui/material/TableRow";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import {
//   Box,
//   Typography,
//   Checkbox,
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableBody,
//   Grid,
//   TextField,
//   InputAdornment,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import axios from "axios";
// import Swal from "sweetalert2";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: "#2196F3",
//     color: theme.palette.common.white,
//     position: "sticky",
//     top: 0,
//     zIndex: 1,
//     padding: "4px 8px",
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//     wordWrap: "break-word",
//     whiteSpace: "normal",
//     padding: "4px 8px",
//   },
// }));
// const StyledTableRow = styled(TableRow)(({ theme, bgcolor }) => ({
//   backgroundColor: bgcolor !== "" ? bgcolor : theme.palette.action.hover,
//   "&:last-child td, &:last-child th": {
//     border: 0,
//   },
//   padding: 0,
//   margin: 0,
//   cursor: "pointer",
// }));
// export default function EMPDetails() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const {
//     EWONO,
//     JOBNO,
//     unassignedList: initialUnassignedList,
//     selectedDate,
//     contractorCode,
//   } = location.state || {};
//   const [unassignedList, setUnassignedList] = useState(
//     initialUnassignedList || []
//   );
//   const [allocatedList, setAllocatedList] = useState([]);
//   const [selectedEmployees, setSelectedEmployees] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [updatedTimes, setUpdatedTimes] = useState({});
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedEmployeeForUpdate, setSelectedEmployeeForUpdate] =
//     useState(null);

//   const fetchAllocatedEmployees = async () => {
//     try {
//       const response = await axios.get("JobAllocation/GetAssignedList", {
//         params: {
//           P_DATE: selectedDate,
//           P_EWO_NO: EWONO,
//           P_CONTRACTOR_CODE: contractorCode,
//         },
//       });
//       if (response.data && response.data.StatusCode === 200) {
//         setAllocatedList(response.data.ResultSet);
//       } else {
//         console.log("Failed to fetch allocated employees.");
//       }
//     } catch (error) {
//       console.error("Error fetching allocated employees:", error);
//       // alert("Error fetching allocated employees.");
//       Swal.fire("Error", "Error fetching allocated employees.", "error");
//     }
//   };
//   useEffect(() => {
//     if (selectedDate && EWONO && contractorCode) {
//       fetchAllocatedEmployees();
//     }
//   }, [selectedDate, EWONO, contractorCode]);
//   const handleCheckboxChange = (employee) => {
//     setSelectedEmployees((prevSelected) =>
//       prevSelected.includes(employee)
//         ? prevSelected.filter((e) => e.BarCodeNo !== employee.BarCodeNo)
//         : [...prevSelected, employee]
//     );
//   };
//   const saveEmployees = async () => {
//     if (selectedEmployees.length === 0) {
//       //alert("No employees selected to save.");
//       Swal.fire("Warning", "No employees selected to save.", "warning");
//       return;
//     }
//     const { isConfirmed } = await Swal.fire({
//       title: "Confirm Save",
//       text: "Are you sure to save selected records?",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//     });

//     if (!isConfirmed) return;

//     const employeesToSave = selectedEmployees.filter(
//       (employee) =>
//         !allocatedList.some(
//           (allocated) => allocated.AS_BarCodeNo === employee.BarCodeNo
//         )
//     );

//     if (employeesToSave.length === 0) {
//       Swal.fire(
//         "Info",
//         "All selected employees are already allocated.",
//         "info"
//       );
//       setSelectedEmployees([]);
//       return;
//     }

//     try {
//       for (const employee of employeesToSave) {
//         const response = await axios.get("JobAllocation/SelectEmployee", {
//           params: {
//             P_DATE: selectedDate,
//             P_TIME_IN: employee.InTime,
//             P_TIME_OUT: employee.OutTime,
//             P_EWO_NO: EWONO,
//             P_BARCODE_CARDNO: employee.BarCodeNo,
//             P_CONTINUED_STATUS: employee.Cont,
//             P_CONTRACTOR_CODE: contractorCode,
//           },
//         });

//         if (response.data && response.data.StatusCode === 200) {
//           setAllocatedList((prev) => [...prev, employee]);
//           setUnassignedList((prev) =>
//             prev.filter((e) => e.BarCodeNo !== employee.BarCodeNo)
//           );
//         } else {
//           //alert(`Employee ${employee.Name} could not be saved.`);
//           Swal.fire(
//             "Error",
//             `Employee ${employee.Name} could not be saved.`,
//             "error"
//           );
//         }
//       }
//       setSelectedEmployees([]);
//       //alert("Selected employees saved successfully!");
//       Swal.fire("Success", "Selected employees saved successfully!", "success");
//       setTimeout(() => {
//         fetchAllocatedEmployees();
//       }, 500);
//     } catch (error) {
//       console.error("Error saving employees:", error);
//       //alert("Error saving employees.");
//       Swal.fire("Error", "Error saving employees.", "error");
//     }
//   };
//   const handleUpdateTimes = (employee) => {
//     const currentDateTime = new Date();
//     setSelectedEmployeeForUpdate(employee);

//     setUpdatedTimes((prevTimes) => ({
//       ...prevTimes,
//       [employee.BarCodeNo]: {
//         inDate: employee.AS_InTime
//           ? new Date(employee.AS_InTime).toISOString().split("T")[0]
//           : "",
//         inTime: employee.AS_InTime
//           ? new Date(employee.AS_InTime).toLocaleTimeString([], {
//               hour: "2-digit",
//               minute: "2-digit",
//               hourCycle: "h23",
//             })
//           : "",
//         outDate: employee.AS_OutTime
//           ? new Date(employee.AS_OutTime).toISOString().split("T")[0]
//           : currentDateTime.toISOString().split("T")[0], 
//         outTime: employee.AS_OutTime
//           ? new Date(employee.AS_OutTime).toLocaleTimeString([], {
//               hour: "2-digit",
//               minute: "2-digit",
//               hourCycle: "h23",
//             })
//           : "", 
//       },
//     }));
//     setOpenDialog(true);
//   };
//   const handleConfirmUpdate = async () => {
//     const { isConfirmed } = await Swal.fire({
//       title: "Confirm Update",
//       text: "Are you sure you want to change the date and time?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//     });

//     if (!isConfirmed) return;

//     try {
//       const updatedEmployee = updatedTimes[selectedEmployeeForUpdate.BarCodeNo];

//       const response = await axios.post(
//         "JobAllocation/UpdateAllocatedTime",
//         null,
//         {
//           params: {
//             P_DATE: updatedEmployee.inDate,
//             P_EWO_NO: EWONO,
//             P_BARCODE_CARDNO: selectedEmployeeForUpdate.AS_BarCodeNo,
//             P_SERIALNO: selectedEmployeeForUpdate.SerialNo || 1,
//             P_SDATE: updatedEmployee.inTime
//               ? `${updatedEmployee.inDate} ${updatedEmployee.inTime}`
//               : null,
//             P_EDATE: updatedEmployee.outTime
//               ? `${updatedEmployee.outDate} ${updatedEmployee.outTime}`
//               : null,
//             P_CONTRACTOR_CODE: contractorCode,
//           },
//         }
//       );

//       if (response.data && response.data.StatusCode === 200) {
//         await Swal.fire(
//           "Success",
//           "Successfully updated the date and time.",
//           "success"
//         );

//         fetchAllocatedEmployees();
//         setOpenDialog(false);
//       } else {
//         Swal.fire("Error", "Failed to update the date and time.", "error");
//       }
//     } catch (error) {
//       console.error("Error updating date and time:", error);
//       Swal.fire("Error", "Error updating date and time.", "error");
//     }
//   };

//   const filteredUnassignedList = unassignedList.filter(
//     (employee) =>
//       employee.BarCodeNo.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       employee.Name.toLowerCase().includes(searchQuery.toLowerCase())
//   );
//   return (
//     <div>
//       <Box sx={{ px: 2 }}>
//         <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
//           {EWONO} | {JOBNO} | Date: {selectedDate}
//         </Typography>
//         <Grid sx={{ mt: 4 }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: "bold", mb: 2, color: "#4caf50" }}
//             >
//               Allocated Employees
//             </Typography>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={() => navigate(-1)}
//               sx={{ textTransform: "none" }}
//             >
//               Back
//             </Button>
//           </Box>
//           <TableContainer
//             component={Paper}
//             sx={{ maxHeight: 260, width: "100%", overflowY: "auto" }}
//           >
//             <Table stickyHeader aria-label="allocated employees table">
//               <TableHead>
//                 <TableRow>
//                   <StyledTableCell align="center" sx={{ width: "10%" }}>
//                     Barcode No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: "50%" }}>
//                     Name
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: "10%" }}>
//                     In Time
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: "10%" }}>
//                     Out Time
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: "20%" }}>
//                     Action
//                   </StyledTableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {allocatedList.map((employee) => (
//                   <StyledTableRow key={employee.AS_BarCodeNo}>
//                     <StyledTableCell align="center">
//                       {employee.AS_BarCodeNo}
//                     </StyledTableCell>
//                     <StyledTableCell align="left">
//                       {employee.AS_Name}
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       {new Date(employee.AS_InTime).toLocaleTimeString([], {
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         hourCycle: "h23",
//                       })}
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       {employee.AS_OutTime
//                         ? new Date(employee.AS_OutTime).toLocaleTimeString([], {
//                             hour: "2-digit",
//                             minute: "2-digit",
//                             hourCycle: "h23",
//                           })
//                         : ""}
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         sx={{ textTransform: "none" }}
//                         onClick={() => handleUpdateTimes(employee)}
//                       >
//                         Update Time
//                       </Button>
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Grid>
//         <Grid sx={{ mt: 4 }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 2,
//             }}
//           >
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: "bold", mb: 2, color: "#2196F3" }}
//             >
//               Unassigned Employees
//             </Typography>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={saveEmployees}
//               sx={{ textTransform: "none" }}
//             >
//               Save
//             </Button>
//           </Box>
//           <TableContainer
//             component={Paper}
//             sx={{ maxHeight: 280, width: "100%", overflowY: "auto" }}
//           >
//             <TextField
//               size="small"
//               id="search"
//               label="Search"
//               variant="outlined"
//               sx={{ width: "100%", mb: 2, backgroundColor: "white" }}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//               }}
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//             <Table stickyHeader aria-label="unassigned employees table">
//               <TableHead>
//                 <TableRow>
//                   <StyledTableCell align="center" sx={{ width: "5%" }}>
//                     Select
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: "1%" }}>
//                     Barcode No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: "79%" }}>
//                     Name
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: "15%" }}>
//                     In Time
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: "15%" }}>
//                     Out Time
//                   </StyledTableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredUnassignedList.map((employee) => (
//                   <StyledTableRow key={employee.BarCodeNo}>
//                     <StyledTableCell align="center">
//                       <Checkbox
//                         checked={selectedEmployees.includes(employee)}
//                         onChange={() => handleCheckboxChange(employee)}
//                       />
//                     </StyledTableCell>

//                     <StyledTableCell align="center">
//                       {employee.BarCodeNo}
//                     </StyledTableCell>

//                     <StyledTableCell align="left">
//                       {employee.Name}
//                     </StyledTableCell>

//                     <StyledTableCell align="center">
//                       {employee.InTime
//                         ? new Date(employee.InTime).toLocaleTimeString([], {
//                             hour: "2-digit",

//                             minute: "2-digit",

//                             hourCycle: "h23",
//                           })
//                         : " "}
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       {employee.OutTime
//                         ? new Date(employee.OutTime).toLocaleTimeString([], {
//                             hour: "2-digit",

//                             minute: "2-digit",

//                             hourCycle: "h23",
//                           })
//                         : " "}
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Grid>
//         <Dialog
//           open={openDialog}
//           onClose={() => setOpenDialog(false)}
//           maxWidth="xs"
//           fullWidth
//         >
//           <DialogTitle>Update Date & Time</DialogTitle>
//           <DialogContent>
//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <TextField
//                   label="In Time"
//                   type="time"
//                   value={
//                     updatedTimes[selectedEmployeeForUpdate?.BarCodeNo]
//                       ?.inTime || ""
//                   }
//                   onChange={(e) =>
//                     setUpdatedTimes((prev) => ({
//                       ...prev,
//                       [selectedEmployeeForUpdate.BarCodeNo]: {
//                         ...prev[selectedEmployeeForUpdate.BarCodeNo],
//                         inTime: e.target.value || null, 
//                       },
//                     }))
//                   }
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item xs={6}>
//                 <TextField
//                   label="Out Time"
//                   type="time"
//                   value={
//                     updatedTimes[selectedEmployeeForUpdate?.BarCodeNo]
//                       ?.outTime || ""
//                   }
//                   onChange={(e) =>
//                     setUpdatedTimes((prev) => ({
//                       ...prev,
//                       [selectedEmployeeForUpdate.BarCodeNo]: {
//                         ...prev[selectedEmployeeForUpdate.BarCodeNo],
//                         outTime: e.target.value || null,
//                       },
//                     }))
//                   }
//                   fullWidth
//                 />
//               </Grid>
//             </Grid>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenDialog(false)} color="secondary">
//               Cancel
//             </Button>
//             <Button onClick={handleConfirmUpdate} color="primary">
//               Confirm
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </div>
//   );
// }





// --------------------- 2026-09-25--------------------------

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Box,
  Typography,
  Checkbox,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  Grid,
  TextField,
  InputAdornment,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  IconButton,
  Stack,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import Swal from "sweetalert2";

/* ---------------- Styled Table Cells ---------------- */
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1976d2",
    color: theme.palette.common.white,
    position: "sticky",
    top: 0,
    zIndex: 1,
    padding: "10px 8px",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.3,
    borderBottom: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "10px 8px",
    wordBreak: "break-word",
    borderBottom: "1px solid #eef2f7",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  transition: "background-color 0.15s ease",
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

/* ---------------- Section Header ---------------- */
const SectionHeader = ({ icon, title, count, color = "#1976d2", bg = "#e3f2fd", action }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1.2,
      gap: 1,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
      <Box
        sx={{
          width: 30,
          height: 30,
          borderRadius: 1.5,
          backgroundColor: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {React.cloneElement(icon, { sx: { color, fontSize: 18 } })}
      </Box>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: { xs: 13.5, sm: 14.5 },
          color: "#16324f",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </Typography>
      {count !== undefined && (
        <Chip
          label={count}
          size="small"
          sx={{
            height: 20,
            fontSize: 10.5,
            fontWeight: 700,
            backgroundColor: bg,
            color,
            flexShrink: 0,
          }}
        />
      )}
    </Box>
    {action}
  </Box>
);

/* ---------------- Time formatter ---------------- */
const formatTime = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
};

/* ---------------- Main Component ---------------- */
export default function EMPDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    EWONO,
    JOBNO,
    unassignedList: initialUnassignedList,
    selectedDate,
    contractorCode,
  } = location.state || {};

  const [unassignedList, setUnassignedList] = useState(
    initialUnassignedList || []
  );
  const [allocatedList, setAllocatedList] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [updatedTimes, setUpdatedTimes] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEmployeeForUpdate, setSelectedEmployeeForUpdate] =
    useState(null);

  const fetchAllocatedEmployees = async () => {
    try {
      const response = await axios.get("JobAllocation/GetAssignedList", {
        params: {
          P_DATE: selectedDate,
          P_EWO_NO: EWONO,
          P_CONTRACTOR_CODE: contractorCode,
        },
      });
      if (response.data && response.data.StatusCode === 200) {
        setAllocatedList(response.data.ResultSet);
      } else {
        console.log("Failed to fetch allocated employees.");
      }
    } catch (error) {
      console.error("Error fetching allocated employees:", error);
      Swal.fire("Error", "Error fetching allocated employees.", "error");
    }
  };

  useEffect(() => {
    if (selectedDate && EWONO && contractorCode) {
      fetchAllocatedEmployees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, EWONO, contractorCode]);

  const handleCheckboxChange = (employee) => {
    setSelectedEmployees((prevSelected) =>
      prevSelected.includes(employee)
        ? prevSelected.filter((e) => e.BarCodeNo !== employee.BarCodeNo)
        : [...prevSelected, employee]
    );
  };

  const saveEmployees = async () => {
    if (selectedEmployees.length === 0) {
      Swal.fire("Warning", "No employees selected to save.", "warning");
      return;
    }
    const { isConfirmed } = await Swal.fire({
      title: "Confirm Save",
      text: "Are you sure to save selected records?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (!isConfirmed) return;

    const employeesToSave = selectedEmployees.filter(
      (employee) =>
        !allocatedList.some(
          (allocated) => allocated.AS_BarCodeNo === employee.BarCodeNo
        )
    );

    if (employeesToSave.length === 0) {
      Swal.fire(
        "Info",
        "All selected employees are already allocated.",
        "info"
      );
      setSelectedEmployees([]);
      return;
    }

    try {
      for (const employee of employeesToSave) {
        const response = await axios.get("JobAllocation/SelectEmployee", {
          params: {
            P_DATE: selectedDate,
            P_TIME_IN: employee.InTime,
            P_TIME_OUT: employee.OutTime,
            P_EWO_NO: EWONO,
            P_BARCODE_CARDNO: employee.BarCodeNo,
            P_CONTINUED_STATUS: employee.Cont,
            P_CONTRACTOR_CODE: contractorCode,
          },
        });

        if (response.data && response.data.StatusCode === 200) {
          setAllocatedList((prev) => [...prev, employee]);
          setUnassignedList((prev) =>
            prev.filter((e) => e.BarCodeNo !== employee.BarCodeNo)
          );
        } else {
          Swal.fire(
            "Error",
            `Employee ${employee.Name} could not be saved.`,
            "error"
          );
        }
      }
      setSelectedEmployees([]);
      Swal.fire("Success", "Selected employees saved successfully!", "success");
      setTimeout(() => {
        fetchAllocatedEmployees();
      }, 500);
    } catch (error) {
      console.error("Error saving employees:", error);
      Swal.fire("Error", "Error saving employees.", "error");
    }
  };

  const handleUpdateTimes = (employee) => {
    const currentDateTime = new Date();
    setSelectedEmployeeForUpdate(employee);

    setUpdatedTimes((prevTimes) => ({
      ...prevTimes,
      [employee.BarCodeNo]: {
        inDate: employee.AS_InTime
          ? new Date(employee.AS_InTime).toISOString().split("T")[0]
          : "",
        inTime: employee.AS_InTime
          ? new Date(employee.AS_InTime).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hourCycle: "h23",
            })
          : "",
        outDate: employee.AS_OutTime
          ? new Date(employee.AS_OutTime).toISOString().split("T")[0]
          : currentDateTime.toISOString().split("T")[0],
        outTime: employee.AS_OutTime
          ? new Date(employee.AS_OutTime).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hourCycle: "h23",
            })
          : "",
      },
    }));
    setOpenDialog(true);
  };

  const handleConfirmUpdate = async () => {
    const { isConfirmed } = await Swal.fire({
      title: "Confirm Update",
      text: "Are you sure you want to change the date and time?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (!isConfirmed) return;

    try {
      const updatedEmployee = updatedTimes[selectedEmployeeForUpdate.BarCodeNo];

      const response = await axios.post(
        "JobAllocation/UpdateAllocatedTime",
        null,
        {
          params: {
            P_DATE: updatedEmployee.inDate,
            P_EWO_NO: EWONO,
            P_BARCODE_CARDNO: selectedEmployeeForUpdate.AS_BarCodeNo,
            P_SERIALNO: selectedEmployeeForUpdate.SerialNo || 1,
            P_SDATE: updatedEmployee.inTime
              ? `${updatedEmployee.inDate} ${updatedEmployee.inTime}`
              : null,
            P_EDATE: updatedEmployee.outTime
              ? `${updatedEmployee.outDate} ${updatedEmployee.outTime}`
              : null,
            P_CONTRACTOR_CODE: contractorCode,
          },
        }
      );

      if (response.data && response.data.StatusCode === 200) {
        await Swal.fire(
          "Success",
          "Successfully updated the date and time.",
          "success"
        );

        fetchAllocatedEmployees();
        setOpenDialog(false);
      } else {
        Swal.fire("Error", "Failed to update the date and time.", "error");
      }
    } catch (error) {
      console.error("Error updating date and time:", error);
      Swal.fire("Error", "Error updating date and time.", "error");
    }
  };

  const filteredUnassignedList = unassignedList.filter(
    (employee) =>
      employee.BarCodeNo.toLowerCase().includes(searchQuery.toLowerCase()) ||
      employee.Name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  /* ---------- Shared table container style ---------- */
  const tableContainerSx = {
    maxHeight: { xs: 340, sm: 300 },
    width: "100%",
    overflowX: "auto",
    borderRadius: 2.5,
    border: "1px solid #e2e8f0",
    boxShadow: "0 2px 10px rgba(25, 118, 210, 0.06)",
    "&::-webkit-scrollbar": { height: 6, width: 6 },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#cbd5e1",
      borderRadius: 3,
    },
  };

  const backButtonSx = {
    textTransform: "none",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 2,
    px: 1.5,
    py: 0.5,
    minHeight: 34,
    borderColor: "#1976d2",
    color: "#1976d2",
    "&:hover": {
      backgroundColor: "#e3f2fd",
      borderColor: "#1976d2",
    },
  };

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 1.5, md: 2 },
        backgroundColor: "#f4f7fb",
        minHeight: "100vh",
      }}
    >
      {/* ================= HEADER INFO CARD ================= */}
      <Box
        sx={{
          backgroundColor: "#ffffff",
          border: "1px solid #e2e8f0",
          borderLeft: "4px solid #1976d2",
          borderRadius: 3,
          boxShadow: "0 4px 16px rgba(25, 118, 210, 0.08)",
          p: { xs: 1.5, sm: 2 },
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
            gap: 1.5,
          }}
        >
          <Box sx={{ minWidth: 0, width: { xs: "100%", sm: "auto" } }}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: { xs: 14, sm: 16 },
                color: "#16324f",
                mb: 0.5,
              }}
            >
              Employee Details
            </Typography>
            <Stack
              direction="row"
              spacing={0.8}
              flexWrap="wrap"
              useFlexGap
              sx={{ rowGap: 0.8 }}
            >
              <Chip
                label={`EWO: ${EWONO || "—"}`}
                size="small"
                sx={{
                  fontSize: 10.5,
                  fontWeight: 600,
                  height: 22,
                  backgroundColor: "#e3f2fd",
                  color: "#1976d2",
                }}
              />
              <Chip
                label={`JOB: ${JOBNO || "—"}`}
                size="small"
                sx={{
                  fontSize: 10.5,
                  fontWeight: 600,
                  height: 22,
                  backgroundColor: "#fff4e5",
                  color: "#ed6c02",
                }}
              />
              <Chip
                label={`Date: ${selectedDate || "—"}`}
                size="small"
                sx={{
                  fontSize: 10.5,
                  fontWeight: 600,
                  height: 22,
                  backgroundColor: "#dcfce7",
                  color: "#166534",
                }}
              />
            </Stack>
          </Box>

          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
            sx={{ ...backButtonSx, alignSelf: { xs: "flex-end", sm: "auto" } }}
          >
            Back
          </Button>
        </Box>
      </Box>

      {/* ================= ALLOCATED EMPLOYEES ================= */}
      <SectionHeader
        icon={<GroupsIcon />}
        title="Allocated Employees"
        count={allocatedList.length}
        color="#2e7d32"
        bg="#dcfce7"
      />

      <TableContainer component={Paper} sx={{ ...tableContainerSx, mb: 3 }}>
        <Table stickyHeader size="small" aria-label="allocated employees table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Barcode</StyledTableCell>
              <StyledTableCell align="left">Name</StyledTableCell>
              <StyledTableCell align="center">In</StyledTableCell>
              <StyledTableCell align="center">Out</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allocatedList.length > 0 ? (
              allocatedList.map((employee) => (
                <StyledTableRow
                  key={employee.AS_BarCodeNo}
                  sx={{ "&:hover": { backgroundColor: "#f1f5f9" } }}
                >
                  <StyledTableCell align="center">
                    <Typography
                      sx={{ fontSize: 11.5, fontWeight: 600, color: "#16324f" }}
                    >
                      {employee.AS_BarCodeNo}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {employee.AS_Name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Chip
                      label={formatTime(employee.AS_InTime)}
                      size="small"
                      sx={{
                        fontSize: 10.5,
                        height: 22,
                        fontWeight: 600,
                        backgroundColor: "#e3f2fd",
                        color: "#1976d2",
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Chip
                      label={formatTime(employee.AS_OutTime)}
                      size="small"
                      sx={{
                        fontSize: 10.5,
                        height: 22,
                        fontWeight: 600,
                        backgroundColor: "#fef3c7",
                        color: "#b45309",
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
                      onClick={() => handleUpdateTimes(employee)}
                      sx={{
                        textTransform: "none",
                        fontSize: 11,
                        fontWeight: 600,
                        borderRadius: 2,
                        px: 1.2,
                        py: 0.4,
                        minHeight: 30,
                        backgroundColor: "#1976d2",
                        boxShadow: "0 2px 6px rgba(25, 118, 210, 0.25)",
                        "&:hover": { backgroundColor: "#0056b3" },
                      }}
                    >
                      Update
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                    No allocated employees
                  </Typography>
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ================= UNASSIGNED EMPLOYEES ================= */}
      <SectionHeader
        icon={<PersonAddAltIcon />}
        title="Unassigned Employees"
        count={filteredUnassignedList.length}
        color="#1976d2"
        bg="#e3f2fd"
        action={
          <Button
            variant="contained"
            size="small"
            startIcon={<SaveIcon sx={{ fontSize: 15 }} />}
            onClick={saveEmployees}
            disabled={selectedEmployees.length === 0}
            sx={{
              textTransform: "none",
              fontSize: 11.5,
              fontWeight: 600,
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              minHeight: 32,
              backgroundColor:
                selectedEmployees.length === 0 ? "#cbd5e1" : "#2e7d32",
              boxShadow:
                selectedEmployees.length === 0
                  ? "none"
                  : "0 2px 8px rgba(46, 125, 50, 0.25)",
              "&:hover": {
                backgroundColor:
                  selectedEmployees.length === 0 ? "#cbd5e1" : "#1b5e20",
              },
              "&.Mui-disabled": {
                backgroundColor: "#e2e8f0",
                color: "#94a3b8",
              },
            }}
          >
            Save {selectedEmployees.length > 0 && `(${selectedEmployees.length})`}
          </Button>
        }
      />

      {/* Search */}
      <TextField
        size="small"
        fullWidth
        placeholder="Search by barcode or name..."
        variant="outlined"
        sx={{
          mb: 1.5,
          backgroundColor: "#ffffff",
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            fontSize: 13,
            height: 40,
            "& fieldset": { borderColor: "#e2e8f0" },
            "&:hover fieldset": { borderColor: "#1976d2" },
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon sx={{ color: "#1976d2", fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <TableContainer component={Paper} sx={tableContainerSx}>
        <Table stickyHeader size="small" aria-label="unassigned employees table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center" sx={{ width: 50 }}>
                Select
              </StyledTableCell>
              <StyledTableCell align="center">Barcode</StyledTableCell>
              <StyledTableCell align="left">Name</StyledTableCell>
              <StyledTableCell align="center">In</StyledTableCell>
              <StyledTableCell align="center">Out</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUnassignedList.length > 0 ? (
              filteredUnassignedList.map((employee) => {
                const isSelected = selectedEmployees.includes(employee);
                return (
                  <StyledTableRow
                    key={employee.BarCodeNo}
                    onClick={() => handleCheckboxChange(employee)}
                    sx={{
                      cursor: "pointer",
                      backgroundColor: isSelected ? "#e3f2fd" : "inherit",
                      "&:hover": { backgroundColor: "#f1f5f9" },
                    }}
                  >
                    <StyledTableCell align="center" padding="checkbox">
                      <Checkbox
                        size="small"
                        checked={isSelected}
                        onChange={() => handleCheckboxChange(employee)}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                          color: "#94a3b8",
                          "&.Mui-checked": { color: "#1976d2" },
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography
                        sx={{
                          fontSize: 11.5,
                          fontWeight: 600,
                          color: "#16324f",
                        }}
                      >
                        {employee.BarCodeNo}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {employee.Name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={formatTime(employee.InTime)}
                        size="small"
                        sx={{
                          fontSize: 10.5,
                          height: 22,
                          fontWeight: 600,
                          backgroundColor: "#e3f2fd",
                          color: "#1976d2",
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={formatTime(employee.OutTime)}
                        size="small"
                        sx={{
                          fontSize: 10.5,
                          height: 22,
                          fontWeight: 600,
                          backgroundColor: "#fef3c7",
                          color: "#b45309",
                        }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            ) : (
              <TableRow>
                <StyledTableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                    No unassigned employees
                  </Typography>
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ================= UPDATE TIME DIALOG ================= */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            m: { xs: 1.5, sm: 2 },
            background: "#ffffff",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
            borderBottom: "1px solid #eef2f7",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 1.5,
                backgroundColor: "#e3f2fd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AccessTimeIcon sx={{ color: "#1976d2", fontSize: 17 }} />
            </Box>
            <Typography
              sx={{ fontWeight: 700, fontSize: 14, color: "#16324f" }}
            >
              Update Date &amp; Time
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setOpenDialog(false)}
            sx={{ color: "#94a3b8" }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 2 }}>
          {/* Employee info chip */}
          {selectedEmployeeForUpdate && (
            <Box
              sx={{
                backgroundColor: "#f8fafc",
                borderRadius: 2,
                p: 1.2,
                mb: 2,
                border: "1px solid #e2e8f0",
              }}
            >
              <Typography sx={{ fontSize: 11, color: "#64748b", mb: 0.3 }}>
                Employee
              </Typography>
              <Typography
                sx={{ fontSize: 13, fontWeight: 700, color: "#16324f" }}
              >
                {selectedEmployeeForUpdate.AS_Name}
              </Typography>
              <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.3 }}>
                {selectedEmployeeForUpdate.AS_BarCodeNo}
              </Typography>
            </Box>
          )}

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="In Time"
                type="time"
                size="small"
                value={
                  updatedTimes[selectedEmployeeForUpdate?.BarCodeNo]?.inTime ||
                  ""
                }
                onChange={(e) =>
                  setUpdatedTimes((prev) => ({
                    ...prev,
                    [selectedEmployeeForUpdate.BarCodeNo]: {
                      ...prev[selectedEmployeeForUpdate.BarCodeNo],
                      inTime: e.target.value || null,
                    },
                  }))
                }
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    fontSize: 13,
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Out Time"
                type="time"
                size="small"
                value={
                  updatedTimes[selectedEmployeeForUpdate?.BarCodeNo]?.outTime ||
                  ""
                }
                onChange={(e) =>
                  setUpdatedTimes((prev) => ({
                    ...prev,
                    [selectedEmployeeForUpdate.BarCodeNo]: {
                      ...prev[selectedEmployeeForUpdate.BarCodeNo],
                      outTime: e.target.value || null,
                    },
                  }))
                }
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    fontSize: 13,
                  },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="outlined"
            startIcon={<CloseIcon sx={{ fontSize: 15 }} />}
            sx={{
              textTransform: "none",
              fontSize: 12,
              fontWeight: 600,
              borderRadius: 2,
              borderColor: "#cbd5e1",
              color: "#64748b",
              flex: { xs: 1, sm: "initial" },
              "&:hover": {
                borderColor: "#94a3b8",
                backgroundColor: "#f8fafc",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmUpdate}
            variant="contained"
            startIcon={<CheckCircleIcon sx={{ fontSize: 15 }} />}
            sx={{
              textTransform: "none",
              fontSize: 12,
              fontWeight: 600,
              borderRadius: 2,
              backgroundColor: "#2e7d32",
              flex: { xs: 1, sm: "initial" },
              boxShadow: "0 2px 8px rgba(46, 125, 50, 0.25)",
              "&:hover": { backgroundColor: "#1b5e20" },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}